import React, {useState} from 'react';
import useAuth from '../../hooks/useAuth';
import useLogout from "../../hooks/useLogout";
import {Link, useNavigate} from "react-router-dom";
import Button from "react-bootstrap/Button";
import ScheduleNotificationBell from "./ScheduleNotificationBell";
import axios from "../../api/axios";
import {buildAuthSession} from "../../helpers/AuthSession";
import "../../css/Impersonation.css";

const PageHeader = ({ valid }) => {

  const logout = useLogout();
  const navigate = useNavigate();
  const { auth, setAuth } = useAuth();
  const [endingImpersonation, setEndingImpersonation] = useState(false);
  const [impersonationError, setImpersonationError] = useState("");

  const signOut = async () => {
    await logout();
    navigate('/');
  };

  const stopImpersonation = async () => {
    if (endingImpersonation) return;
    setEndingImpersonation(true);
    setImpersonationError("");
    try {
      const response = await axios.post('/api/impersonation/stop', null, {withCredentials: true});
      setAuth(buildAuthSession(response.data));
      navigate('/app/users', {replace: true});
    } catch (error) {
      const data = error?.response?.data;
      setImpersonationError(
        data?.error_message || data?.message || "Nie udało się wrócić do sesji administratora."
      );
    } finally {
      setEndingImpersonation(false);
    }
  };

  return (
    <>
      <nav className="navbar justify-content-between navbar-dark bg-dark sticky-top">
        <Link className="navbar-brand ps-3" to="/">Witaj na Farmie Iluzji</Link>
        <div className="qstaff-header-actions">
          <button className="btn btn-link btn-sm order-1 order-lg-0 me-2" id="sidebarToggle" href="#!" aria-label="Pokaż lub ukryj menu">
            <i className="fas fa-bars"></i>
          </button>
          {valid && auth?.user ? (
            <>
              <Link className="qstaff-header-kb-button" to="/app/knowledge-base" title="Baza wiedzy i przewodnik po Qstaff">
                <i className="fas fa-book-open" aria-hidden="true"></i>
                <span>Baza wiedzy</span>
              </Link>
              <ScheduleNotificationBell/>
              <div className="qstaff-header-user">
                <span>Zalogowany jako {auth.displayName || auth.user}</span>
                <Button className="mx-3" onClick={signOut}>Wyloguj</Button>
              </div>
            </>
          ) : valid ? (
            <div className="qstaff-header-user">
              <span className="mx-4">Nie jesteś zalogowany/a</span>
            </div>
          ) : null}
        </div>
      </nav>
      {valid && auth?.impersonated && (
        <div className="qstaff-impersonation-banner" role="status">
          <div className="qstaff-impersonation-banner-text">
            <strong>Tryb podglądu użytkownika</strong>
            <span>
              Pracujesz jako <b>{auth.displayName || auth.user}</b> ({auth.user}).
              Administrator: <b>{auth.impersonatorDisplayName || auth.impersonatorUser}</b>.
            </span>
            {impersonationError && <small>{impersonationError}</small>}
          </div>
          <Button size="sm" variant="light" onClick={stopImpersonation} disabled={endingImpersonation}>
            {endingImpersonation ? "Przywracanie…" : "Wróć do administratora"}
          </Button>
        </div>
      )}
    </>
  );
};

export default PageHeader;
